module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "research-background-color service-container",
    staticStyle: {
      "right": "-195px"
    },
    attrs: {
      "id": "service"
    },
    on: {
      "touchmove": _vm.handleTouchMove,
      "touchstart": _vm.handleTouchStart,
      "touchend": _vm.handleTouchEnd,
      "click": _vm.tokefuMessage
    }
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-kefu1 icon-size",
    staticStyle: {
      "margin-left": "6px"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11248523","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/components/CustomerService.vue
// module id = 1540
// module chunks = 8